import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";

import { ActionButtons } from "@components";
import { LocalTrainingForm } from "./LocalTrainingForm";

import { LocalTrainingType } from "@type/HRM/qualification";
import {
  LOCAL_TRAINING,
  localTrainingValidation,
} from "@validations/HRM/employee/qualificationsValidation";
import { convertSingleDocumentData } from "@utils/documentDataConvert";

interface NewLocalTrainingPropsType {
  handleNewLocalTrainingFormShow: (param: boolean) => void;
  changeLocalTrainingsInfo: (data: LocalTrainingType) => void;
  updateLocalTrainingRequestOngoing: boolean;
  isProfileDisabled: boolean;
}

export const NewLocalTraining = ({
  handleNewLocalTrainingFormShow,
  changeLocalTrainingsInfo,
  updateLocalTrainingRequestOngoing,
  isProfileDisabled,
}: NewLocalTrainingPropsType) => {
  const methods = useForm<LocalTrainingType>({
    resolver: yupResolver(localTrainingValidation),
  });

  const { handleSubmit } = methods;
  const onSubmit: SubmitHandler<LocalTrainingType> = (
    data: LocalTrainingType,
  ) => {
    changeLocalTrainingsInfo(
      convertSingleDocumentData(data, LOCAL_TRAINING.UPLOAD_CERTIFICATE),
    );
    handleNewLocalTrainingFormShow(false);
  };

  return (
    <FormProvider {...methods}>
      <form className="container" onSubmit={handleSubmit(onSubmit)}>
        <LocalTrainingForm isProfileDisabled={isProfileDisabled} />
        <ActionButtons
          isSaving={updateLocalTrainingRequestOngoing}
          disabled
          closeAction={() => handleNewLocalTrainingFormShow(false)}
        />
      </form>
    </FormProvider>
  );
};
